"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var l = require("lenovo");
var lsbInstall = require("../../lsbsetup/src/lsbsetup");
var lsbInstallStatus = require("../../lsbsetup/src/lsbupdate");
var adup_load_1 = require("./adup-load");
var adup_exception_1 = require("./adup-exception");
var adup_exception_2 = require("./adup-exception");
var adup_exception_3 = require("./adup-exception");
var adup_exception_4 = require("./adup-exception");
var adup_tvsu_1 = require("./adup-tvsu");
var adup_tvsu_2 = require("./adup-tvsu");
var adup_lastupdate_1 = require("./adup-lastupdate");
var adup_tip_1 = require("./adup-tip");
window['_eventCallback'] = null;
var translates = l.Translator.translate;
var ADUPTrack = function (type, name, action, extend) {
    setTimeout(function () {
        l.DTM.push({
            type: type,
            name: name,
            action: action
        });
    }, 100);
};
var ThreeStep_ADUPTrack = function (type, name, action, sn, mt, extend) {
    setTimeout(function () {
        l.DTM.Lmd.unifiedSubmissionTrack({
            type: type,
            name: name,
            action: action,
            serialNumber: sn,
            machinetype: mt
        }, type);
    }, 100);
};
var IsThreeStepPage = function () {
    if (window.location.href.toLowerCase().indexOf("/threesteps") > -1) {
        return true;
    }
    else {
        return false;
    }
};
var ADUPTrackError = function (type, name) {
    setTimeout(function () {
        l.DTM.Lmd.pusherrorinfTrack(type, name);
    }, 100);
};
var SeverityViewMap = function (key) {
    if (typeof key == 'string') {
        switch (key.toLowerCase()) {
            case 'recommended':
                return translates('recommended');
            case 'optional':
                return translates('optional');
            case 'critical':
                return translates('critical');
        }
    }
    return key;
};
var TimeMonitor = {
    list: {},
    scan: "ScanStart",
    install: "InstallPackages",
    start: function (name) { TimeMonitor.list[name] = new Date(); },
    getTime: function (name) { return Math.floor((new Date().getTime() - TimeMonitor.list[name].getTime()) / 1000); },
    clear: function () { TimeMonitor.list = {}; }
};
var AdupResultDisplay;
(function (AdupResultDisplay) {
    AdupResultDisplay[AdupResultDisplay["scan"] = 0] = "scan";
    AdupResultDisplay[AdupResultDisplay["update"] = 1] = "update";
})(AdupResultDisplay || (AdupResultDisplay = {}));
var AdupStepModel = /** @class */ (function () {
    function AdupStepModel() {
        this.Active = false;
        this.ScanProgress = 0;
        this.UpdateProgress = 0;
        this.ScanActive = false;
        this.UpdateActive = false;
        this.ScanFailed = false;
        this.UpdateFailed = false;
        this.Completed = false;
    }
    return AdupStepModel;
}());
var AdupStep = /** @class */ (function (_super) {
    __extends(AdupStep, _super);
    function AdupStep(props) {
        return _super.call(this, props) || this;
    }
    AdupStep.prototype.render = function () {
        var scanProgress = { width: this.props.ScanProgress.toString() + "%" };
        var updateProgress = this.props.UpdateFailed ? { width: "0%" } : { width: this.props.UpdateProgress.toString() + "%" };
        return React.createElement("div", { className: "dow-adup-guide" },
            React.createElement("ul", { className: "dow-adup-guide-steps" },
                React.createElement("li", null,
                    React.createElement("span", { className: "dow-guide-line", style: scanProgress }, (this.props.ScanProgress > 0 && this.props.ScanProgress < 100) ? React.createElement("span", { className: "dow-guide-line-load" }) : null),
                    this.props.ScanFailed == true ? React.createElement("span", { className: "dow-guide-line dow-guide-line-failed" }) : null,
                    React.createElement("span", { "data-guide-active": this.props.ScanActive && !this.props.ScanFailed, className: "dow-guide-step dow-guide-step-first " + (this.props.ScanFailed ? "dow-guide-step-failed" : "") }),
                    React.createElement("span", { className: "dow-guide-title " }, translates("adup start|Start Scan")),
                    React.createElement("span", { className: "dow-guide-decription", style: { display: this.props.ScanFailed == true ? "block" : "none" } }, translates("adup scan failed|Scan failed")),
                    React.createElement("span", { className: "dow-guide-decription", style: { display: (this.props.ScanFailed == false && this.props.ScanProgress == 100) ? "block" : "none" } }, translates("adup success"))),
                React.createElement("li", null,
                    React.createElement("span", { className: "dow-guide-line ", style: updateProgress }, (this.props.UpdateProgress > 0 && this.props.UpdateProgress < 100 && this.props.Completed == false) ? React.createElement("span", { className: "dow-guide-line-load" }) : null),
                    this.props.UpdateFailed == true ? React.createElement("span", { className: "dow-guide-line dow-guide-line-failed" }) : null,
                    React.createElement("span", { "data-guide-active": (!this.props.ScanFailed && !this.props.UpdateFailed && this.props.ScanProgress == 100) || (this.props.UpdateActive && !this.props.UpdateFailed), className: "dow-guide-step " + ((this.props.ScanFailed || this.props.UpdateFailed) ? "dow-guide-step-failed" : "") }),
                    React.createElement("span", { className: "dow-guide-title" }, translates("Select Drivers|Select Drivers")),
                    React.createElement("span", { className: "dow-guide-decription", style: { display: this.props.UpdateFailed == true ? "block" : "none" } }, translates("update failed")),
                    React.createElement("span", { className: "dow-guide-decription", style: { display: (this.props.UpdateFailed == false && this.props.UpdateProgress == 100) ? "block" : "none" } }, translates("update completed"))),
                React.createElement("li", null,
                    React.createElement("span", { "data-guide-active": this.props.Completed && !this.props.UpdateFailed, className: "dow-guide-step dow-guide-step-last " + (this.props.UpdateFailed ? "dow-guide-step-failed" : "") }),
                    React.createElement("span", { className: "dow-guide-title" }, translates("Update Completed|Update Completed")))));
    };
    return AdupStep;
}(React.Component));
var AdupResultItemModel = /** @class */ (function () {
    function AdupResultItemModel() {
        this.Released = "";
        this.Selected = false;
        this.Index = -1;
        this.pattern = AdupResultDisplay.scan;
        this.Action = -1;
    }
    return AdupResultItemModel;
}());
var AdupResultItem = /** @class */ (function (_super) {
    __extends(AdupResultItem, _super);
    function AdupResultItem(props) {
        return _super.call(this, props) || this;
    }
    AdupResultItem.prototype.render = function () {
        var _this = this;
        var showYesMessage = translates("require reboot upon driver download|Computer will require a reboot upon driver download");
        if (window.location.href.indexOf('/threesteps') >= 0) {
            showYesMessage = translates("require threesteps reboot upon driver download|Computer will require a reboot upon driver download. Please re-start the tool 3 Steps to Solution after the reboot to finish the diagnostic of your machine.");
        }
        return (React.createElement("ul", { className: "dow-adup-result-item" },
            React.createElement("li", { className: "col-xs-5 dow-adup-result-item-child" },
                React.createElement("a", { className: "dow-adup-result-list-title", href: this.props.Url }, AdupResult.replace3264(this.props.Title))),
            React.createElement("li", { className: "col-xs-1 dow-adup-result-item-child text-center" },
                AdupResult.ConvertMB(this.props.DownloadSize),
                "M"),
            React.createElement("li", { className: "col-xs-1 dow-adup-result-item-child text-center" }, this.props.Version),
            React.createElement("li", { className: "col-xs-2 dow-adup-result-item-child text-center" }, AdupResult.ConvertREBOOTTYPE(this.props.RebootType)),
            React.createElement("li", { className: "col-xs-2 dow-adup-result-item-child text-center" }, SeverityViewMap(this.props.Severity)),
            React.createElement("li", { className: "col-xs-1 dow-adup-result-item-child text-center dow-adup-r-item-li" },
                this.props.pattern == AdupResultDisplay.scan ? React.createElement("a", { onClick: function () { _this.props.SelectHandle(_this.props.Index); } },
                    React.createElement("span", { className: "adup-icon-blue " + (this.props.Selected ? "icon-success adup-icon-success" : "icon-lenovo-drivers-single-check-icon") })) : null,
                (this.props.pattern == AdupResultDisplay.update && this.props.Status <= LSBV4.Component.InstallPackageStatusEnum.downloading) ? React.createElement("span", { className: "adup-icon-green psp-dl-download dow-adup-downloading" }) : null,
                (this.props.pattern == AdupResultDisplay.update && this.props.Status == LSBV4.Component.InstallPackageStatusEnum.download_successful) ? React.createElement("span", { className: "adup-icon-green icon-check-icon" }) : null,
                (this.props.pattern == AdupResultDisplay.update && this.props.Status == LSBV4.Component.InstallPackageStatusEnum.installing) ? React.createElement("span", { className: "dow-adup-update-load" }) : null,
                (this.props.pattern == AdupResultDisplay.update && this.props.Status == LSBV4.Component.InstallPackageStatusEnum.install_successful) ? React.createElement("span", { className: "adup-icon-green icon-yes" }) : null,
                (this.props.pattern == AdupResultDisplay.update && (this.props.Status == LSBV4.Component.InstallPackageStatusEnum.install_fail || this.props.Status == LSBV4.Component.InstallPackageStatusEnum.download_fail)) ? React.createElement("span", { className: "adup-icon-error icon-adup-error" },
                    React.createElement(adup_tip_1.AdupToolTip, { content: translates("adup update error message|Your driver update process is failed, please rerun scan") })) : null,
                (this.props.pattern == AdupResultDisplay.update && (this.props.Status == LSBV4.Component.InstallPackageStatusEnum.install_fail || this.props.Status == LSBV4.Component.InstallPackageStatusEnum.download_fail)) ? React.createElement("span", { className: "dow-adup-icon-failed" }, translates("result failed|Failed")) : null),
            AdupResult.ConvertREBOOTTYPE(this.props.RebootType) == translates("YES") ? React.createElement("li", { className: "col-xs-10 row dow-adup-result-tip" }, showYesMessage) : null));
    };
    return AdupResultItem;
}(React.Component));
var AdupUpdateResultModel = /** @class */ (function () {
    function AdupUpdateResultModel() {
        this.visible = false;
        this.action = LSBV4.Component.InstallPackageActionEnum.Downloading;
        this.downloadingProgress = -1;
        this.showInstallLog = false;
        this.log = '';
        this.scanFinish = false;
    }
    return AdupUpdateResultModel;
}());
var AdupResultModel = /** @class */ (function () {
    function AdupResultModel() {
        this.Drivers = [];
        this.active = false;
        this.rebootRequired = false;
        this.pattern = AdupResultDisplay.scan;
    }
    return AdupResultModel;
}());
var AdupResultState = /** @class */ (function () {
    function AdupResultState() {
        this.exception = LSBV4.Component.ADUPExceptionEnum.None;
        this.specialException = '';
        this.showLoading = false;
        this.showInstallPackage = false;
        this.showInstallTVSU = false;
    }
    return AdupResultState;
}());
var AdupResult = /** @class */ (function (_super) {
    __extends(AdupResult, _super);
    function AdupResult(props) {
        var _this = _super.call(this, props) || this;
        _this.showTVSUDownloadFinishPopup = false;
        _this.closeException = function () {
            var stateModel = new AdupResultState();
            stateModel.exception = LSBV4.Component.ADUPExceptionEnum.None;
            _this.setState(stateModel);
        };
        _this.rebootClose = function () {
            var stateModel = new AdupResultState();
            stateModel.exception = LSBV4.Component.ADUPExceptionEnum.None;
            stateModel.showInstallPackage = true;
            _this.setState(stateModel);
        };
        _this.cancelDownloadTVSU = function () {
            var stateModel = new AdupResultState();
            stateModel.showLoading = true;
            stateModel.exception = LSBV4.Component.ADUPExceptionEnum.Waiting;
            _this.setState(stateModel);
            _this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.ADUP, LSBV4.Component.CommandTypeEnum.DownloadAppCancel);
            var isThreePage = IsThreeStepPage();
            //ADUPTrack("eSupportProcess_Complete", "ADUP:DownloadTVSUCancel","Button click");
            ADUPTrackError("ADUP", "DownloadTVSUCancel");
        };
        _this.downloadTVSU = function () {
            _this.showTVSUDownloadFinishPopup = true;
            var stateModel = new AdupResultState();
            stateModel.showLoading = true;
            _this.setState(stateModel);
            _this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.ADUP, LSBV4.Component.CommandTypeEnum.InstallApp);
            var isThreePage = IsThreeStepPage();
            ADUPTrack("eSupportProcess_Complete", "ADUP:DownloadTVSU", "Button Click");
        };
        _this.cancelInstallTVSU = function () {
            var stateModel = new AdupResultState();
            stateModel.showLoading = true;
            _this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.ADUP, LSBV4.Component.CommandTypeEnum.InstallAppCancel);
            //ADUPTrack("eSupportProcess_Complete", "ADUP:InstallTVSUCancel", "Button Click");
            ADUPTrackError("ADUP", "InstallTVSUCancel");
            _this.setState(_this.state);
        };
        _this.installPackageLogToggleHanlder = function () {
        };
        _this.updateModels = function () {
            //this.exceptionPopupModel.visible = this.state.exception !== LSBV4.Component.ADUPExceptionEnum.None && this.state.exception !== LSBV4.Component.ADUPExceptionEnum.Waiting || this.state.specialException !== '';
            _this.exceptionPopupModel.visible = _this.state.exception == LSBV4.Component.ADUPExceptionEnum.NoTVSU;
            _this.exceptionPopupModel.exception = _this.state.exception;
            _this.exceptionPopupModel.specialException = _this.state.specialException;
            _this.installTVSUPopupModel.visible = _this.state.showInstallTVSU;
        };
        _this.state = new AdupResultState();
        _this.dispatcher = _this.props.dispatcher;
        _this.initModel();
        _this.initEvents();
        return _this;
    }
    AdupResult.prototype.initFunctions = function () {
        this.closeException = this.closeException.bind(this);
        this.cancelDownloadTVSU = this.cancelDownloadTVSU.bind(this);
        this.downloadTVSU = this.downloadTVSU.bind(this);
        this.installPackageLogToggleHanlder = this.installPackageLogToggleHanlder.bind(this);
    };
    AdupResult.prototype.initModel = function () {
        this.adupUpdateList = this.props.Drivers;
        this.adupUpdateResultModel = new AdupUpdateResultModel();
        this.exceptionPopupModel = new adup_exception_1.ExceptionPopupModel();
        this.exceptionPopupModel.closeExceptionHandler = this.closeException;
        this.exceptionPopupModel.cancelDownloadTVSUHandler = this.cancelDownloadTVSU;
        this.exceptionPopupModel.downloadTVSUHandler = this.downloadTVSU;
        this.exceptionPopupModel.rebootCloseHandler = this.rebootClose;
        this.installTVSUPopupModel = new adup_tvsu_1.InstallTVSUPopupModel();
        this.installTVSUPopupModel.cancelInstallTVSUHandler = this.cancelInstallTVSU;
    };
    AdupResult.prototype.initEvents = function () {
        var _this = this;
        /*********LSBEvent**************/
        //Handle with exception
        this.dispatcher.BatchAddEventListener(function (data, eventType) {
            if (data != null && eventType != LSBV4.Utility.EventTypeEnum.Waiting) {
                _this.adupUpdateResultModel.scanFinish = false;
                var stateModel = new AdupResultState();
                stateModel.showInstallPackage = _this.state.showInstallPackage;
                stateModel.exception = parseInt(data.Exception);
                if (eventType != null) {
                    if (eventType == LSBV4.Utility.EventTypeEnum.NoTVSU) {
                        _this.state.showLoading = true;
                    }
                    else if (eventType == LSBV4.Utility.EventTypeEnum.TVSUUpdateFailed) {
                        if (data.ErrorMessage != null && data.ErrorMessage !== '') {
                            stateModel.specialException = 'External***' + data.ErrorMessage;
                        }
                    }
                }
                _this.setState(stateModel);
            }
            if (eventType != null) {
                if (eventType == LSBV4.Utility.EventTypeEnum.Waiting) {
                    _this.state.showLoading = true;
                    _this.setState(_this.state);
                }
                else {
                    if (eventType == LSBV4.Utility.EventTypeEnum.ErrorLaunchTVSU || eventType == LSBV4.Utility.EventTypeEnum.ErrorDownloadTVSU || eventType == LSBV4.Utility.EventTypeEnum.TVSUUpdateFailed) {
                        ADUPTrackError("ADUP", LSBV4.Utility.EventTypeEnum[eventType]);
                    }
                    else {
                        if (eventType != LSBV4.Utility.EventTypeEnum.NoTVSU) {
                            ADUPTrack("eSupportProcess_Complete", "ADUP:" + LSBV4.Utility.EventTypeEnum[eventType], "System Generated");
                        }
                    }
                }
            }
        }, LSBV4.Utility.EventTypeEnum.NotLenovo, LSBV4.Utility.EventTypeEnum.Waiting, LSBV4.Utility.EventTypeEnum.SystemNotSupport, LSBV4.Utility.EventTypeEnum.WrongRequest, LSBV4.Utility.EventTypeEnum.NoTVSU, LSBV4.Utility.EventTypeEnum.ErrorLaunchTVSU, LSBV4.Utility.EventTypeEnum.ErrorDownloadTVSU, LSBV4.Utility.EventTypeEnum.LowVersion, LSBV4.Utility.EventTypeEnum.UnhandledException, LSBV4.Utility.EventTypeEnum.TVSUUpdateFailed);
        this.dispatcher.BatchAddEventListener(function (data, eventType) {
            var stateModel = new AdupResultState();
            _this.setState(stateModel);
        }, LSBV4.Utility.EventTypeEnum.ADUPSuccess);
        //Handle with no exception
        this.dispatcher.BatchAddEventListener(function (data, eventType) {
            var stateModel = new AdupResultState();
            _this.setState(stateModel);
            if (eventType != null) {
                if (eventType == LSBV4.Utility.EventTypeEnum.ADUPCancelSuccess) {
                    //ADUPTrack("eSupportProcess_Complete", "ADUP:ADUPCancelSuccess","System Generated");
                }
                else if (eventType == LSBV4.Utility.EventTypeEnum.ADUPInstallConfirmNo) {
                    window["ADUPInstallConfirmNo"] = true;
                    console.log("ADUPInstallConfirmNo The First triggered.");
                }
                else {
                    ADUPTrack("eSupportProcess_Complete", "ADUP:" + LSBV4.Utility.EventTypeEnum[eventType], "System Generated");
                }
            }
        }, LSBV4.Utility.EventTypeEnum.ADUPCancelSuccess, LSBV4.Utility.EventTypeEnum.ADUPInstallConfirmNo, LSBV4.Utility.EventTypeEnum.InstallTVSUSuccess, LSBV4.Utility.EventTypeEnum.DownloadTVSUPause);
        this.dispatcher.BatchAddEventListener(function (data, eventType) {
            var stateModel = new AdupResultState();
            _this.setState(stateModel);
            if (eventType != null) {
                if (eventType == LSBV4.Utility.EventTypeEnum.DownloadTVSUError) {
                    ADUPTrackError("ADUP", LSBV4.Utility.EventTypeEnum[eventType]);
                }
                else if (eventType == LSBV4.Utility.EventTypeEnum.DownloadTVSUCancel || eventType == LSBV4.Utility.EventTypeEnum.InstallTVSUCancelled) {
                    console.log("DownloadTVSUCancel Or InstallTVSUCancelled triggered");
                }
                else {
                    ADUPTrack("eSupportProcess_Complete", LSBV4.Utility.EventTypeEnum[eventType], "System Generated");
                }
                if (_eventCallback) {
                    Cookies.set("TvsuLastRunStatus", 1, { expires: 365, path: '/' });
                    _eventCallback("default error");
                }
            }
        }, LSBV4.Utility.EventTypeEnum.UserCancelled, LSBV4.Utility.EventTypeEnum.ADUPCancelFailed, LSBV4.Utility.EventTypeEnum.InstallTVSUCancelled, LSBV4.Utility.EventTypeEnum.InstallTVSUCancelFailed, LSBV4.Utility.EventTypeEnum.DownloadTVSUCancel, LSBV4.Utility.EventTypeEnum.DownloadTVSUCancelFailed, LSBV4.Utility.EventTypeEnum.DownloadTVSUError);
        //Handle with Download Complete special exception
        this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.InstallTVSUInstalling, function (data) {
            if (_this.showTVSUDownloadFinishPopup === true) {
                _this.showTVSUDownloadFinishPopup = false;
                var stateModel = new AdupResultState();
                stateModel.specialException = 'Download Complete';
                stateModel.showLoading = true;
                _this.setState(stateModel);
            }
        });
        //Handle scan complete 
        this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.ADUPStatusSuccess, function (data) {
            var stateModel = new AdupResultState();
            stateModel.showLoading = false;
            _this.setState(stateModel);
        });
        this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.ADUPInstallStatus, function (data) {
            var stateModel = new AdupResultState();
            stateModel.showLoading = false;
            _this.setState(stateModel);
        });
        this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.DownloadTVSUStatus, function (data) {
            var stateModel = new AdupResultState();
            stateModel.showLoading = true;
            if (data == null) {
                stateModel.exception = LSBV4.Component.ADUPExceptionEnum.UnhandledException;
                _this.setState(stateModel);
            }
            else {
                if (data.Data != null && data.Data.length != null && data.Data.length > 0 && data.Data[0].status != null) {
                    if (parseInt(data.Data[0].status) === LSBV4.Component.DownloadStatus.Completed) {
                        if (_this.showTVSUDownloadFinishPopup === true) {
                            _this.showTVSUDownloadFinishPopup = false;
                            //let stateModel = new AdupResultState();
                            stateModel.specialException = 'Download Complete';
                            //stateModel.showLoading = true;
                            _this.setState(stateModel);
                            ADUPTrack("eSupportProcess_Complete", "ADUP:DownloadTVSU_Complete", "System Generated");
                        }
                    }
                    else {
                        stateModel.showInstallTVSU = true;
                        _this.installTVSUPopupModel.visible = true;
                        _this.installTVSUPopupModel.downloadList = data.Data;
                    }
                }
                _this.setState(stateModel);
            }
        });
    };
    AdupResult.prototype.render = function () {
        var _this = this;
        this.updateModels();
        var ItemList = this.props.Drivers.map(function (item, index) {
            var itemModel = new AdupResultItemModel();
            $.extend(itemModel, item);
            itemModel.SelectHandle = _this.props.selectHandle;
            itemModel.Index = index;
            item.pattern = _this.props.pattern;
            return React.createElement(AdupResultItem, __assign({}, itemModel));
        });
        return React.createElement("div", { className: "dow-adup-result-list" },
            React.createElement("div", { style: { display: this.props.active ? "block" : "none", width: "100%" } },
                React.createElement("ul", { className: "dow-adup-result-item dow-adup-result-item-title", style: { display: ItemList && ItemList.length > 0 ? 'block' : 'none' } },
                    React.createElement("li", { className: "col-xs-5 dow-adup-result-item-child text-left" }, translates("title")),
                    React.createElement("li", { className: "col-xs-1 dow-adup-result-item-child text-center" }, translates("size")),
                    React.createElement("li", { className: "col-xs-1 dow-adup-result-item-child text-center" }, translates("version")),
                    React.createElement("li", { className: "col-xs-2 dow-adup-result-item-child text-center" }, translates("reboot required|Reboot Required")),
                    React.createElement("li", { className: "col-xs-2 dow-adup-result-item-child text-center" }, translates("severity")),
                    React.createElement("li", { className: "col-xs-1 dow-adup-result-item-child text-center" }, (this.props.pattern == AdupResultDisplay.update ? translates("status|Status") : translates("select|Select")))),
                ItemList.length > 0
                    ?
                        ItemList
                    :
                        React.createElement("div", { className: "dow-adup-result-empty" },
                            React.createElement("span", null, translates('No drivers are required to update for your machine')))),
            React.createElement(adup_exception_2.ExceptionPopup, __assign({}, this.exceptionPopupModel)),
            React.createElement(adup_tvsu_2.InstallTVSUPopup, __assign({}, this.installTVSUPopupModel)),
            React.createElement(adup_load_1.AdupLoad, { isShow: this.state.showLoading }));
    };
    AdupResult.replace3264 = function (data) {
        if (data) {
            return data.replace("[64]", "").replace("[32]", "").replace("[32,64]", "");
        }
        return data;
    };
    AdupResult.ConvertMB = function (data) {
        var dataFloat = data == null ? 0 : parseFloat(data);
        dataFloat = isNaN(dataFloat) ? 0 : dataFloat;
        dataFloat = dataFloat < 0 ? 0 : dataFloat;
        return (dataFloat / (1024 * 1024)).toFixed(2);
    };
    AdupResult.ConvertREBOOTTYPE = function (data) {
        if (data === "Default")
            return translates("NO");
        else if (data === "RebootRequired")
            return translates("YES");
        else if (data === "RebootForced")
            return translates("YES");
        else
            return translates("NO");
    };
    return AdupResult;
}(React.Component));
var AdupPackageInfo = /** @class */ (function () {
    function AdupPackageInfo() {
        this.ID = "";
        this.Title = "";
        this.Dependency = "";
    }
    return AdupPackageInfo;
}());
var AdupModel = /** @class */ (function () {
    function AdupModel() {
        this.AdupModeType = 0;
        this.pageType = 0;
    }
    return AdupModel;
}());
var AdupUpdateModel = /** @class */ (function () {
    function AdupUpdateModel() {
        this.updateItems = [];
        this.rebootRequired = false;
    }
    return AdupUpdateModel;
}());
var AdupState = /** @class */ (function (_super) {
    __extends(AdupState, _super);
    function AdupState() {
        var _this = _super.call(this) || this;
        _this.showStartBtn = true;
        _this.showReStartBtn = false;
        _this.showReScan = false;
        _this.showProgress = false;
        _this.showRST = false;
        _this.exception = LSBV4.Component.ADUPExceptionEnum.None;
        _this.isCancelled = false;
        _this.showUpdate = false;
        _this.showCancel = true;
        _this.loading = false;
        _this.subSeries = "";
        _this.Drivers = [];
        _this.rstModel = AdupResultDisplay.scan;
        return _this;
    }
    return AdupState;
}(AdupStepModel));
var Adup = /** @class */ (function (_super) {
    __extends(Adup, _super);
    function Adup(props) {
        var _this = _super.call(this, props) || this;
        _this.installPackage = function () {
            _this.adupUpdateModel.rebootRequired = false;
            var dependencyIDs = "";
            _this.adupUpdateModel.updateItems.forEach(function (item, idx) {
                var dependency = item.Dependency;
                var rebootrequired = AdupResult.ConvertREBOOTTYPE(item.RebootType);
                if (_this.adupUpdateModel.rebootRequired === false && rebootrequired == "YES") {
                    _this.adupUpdateModel.rebootRequired = true;
                }
                if (dependency !== "") {
                    if (dependencyIDs.lastIndexOf(",") === dependencyIDs.length - 1) {
                        dependencyIDs += dependency;
                    }
                    else {
                        dependencyIDs += ("," + dependency);
                    }
                    var updatedItem = _this.adupUpdateModel.updateItems.filter(function (d) { return d.ID == dependency; });
                    if (updatedItem == null || updatedItem.length <= 0) {
                        var dependencyItem = _this.state.Drivers.filter(function (d) { return d.ID == dependency; });
                        if (dependencyItem != null && dependencyItem.length != null && dependencyItem.length > 0) {
                            dependencyItem[0].Selected = true;
                            _this.adupUpdateModel.updateItems.push(dependencyItem[0]);
                        }
                    }
                }
            });
            _this.state.showUpdate = false;
            _this.state.UpdateActive = true;
            _this.state.rstModel = AdupResultDisplay.update;
            _this.setState(_this.state);
            var jsonString = JSON.stringify(_this.adupUpdateModel.updateItems.map(function (item) {
                var objAdd = new AdupPackageInfo();
                objAdd.ID = item.ID;
                return objAdd;
            }));
            if (jsonString != "") {
                _this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.ADUP, LSBV4.Component.CommandTypeEnum.InstallPackage, jsonString);
                ADUPTrack("eSupportProcess_Complete", "ADUP:InstallPackages", "Button Click");
                TimeMonitor.start(TimeMonitor.install);
            }
            //this.forceUpdate();
        };
        _this.InitEventHandler = function () {
            _this.dispatcher.BatchAddEventListener(function (data, eventType) {
                if (_this.state.rstModel == AdupResultDisplay.scan) {
                    _this.state.ScanFailed = true;
                    _this.state.ScanProgress = 0;
                    _this.state.showReStartBtn = true;
                    _this.state.showCancel = false;
                }
                else {
                    _this.state.UpdateFailed = true;
                    _this.state.UpdateProgress = 0;
                    _this.state.Completed = true;
                    _this.state.showUpdate = true;
                    _this.state.rstModel = AdupResultDisplay.scan;
                }
                _this.state.exception = data.Exception;
                if (eventType == LSBV4.Utility.EventTypeEnum.TVSUUpdateFailed) {
                    if (data.ErrorMessage != null && data.ErrorMessage !== '') {
                        _this.state.specialException = 'External***' + data.ErrorMessage;
                    }
                }
                _this.setState(_this.state);
                //ADUPTrack("eSupportProcess_Complete", "ADUP_ScanFaild:"+LSBV4.Utility.EventTypeEnum[eventType]+";"+TimeMonitor.getTime(TimeMonitor.scan)+'s', "System Generated");
            }, 
            //Exceptions
            LSBV4.Utility.EventTypeEnum.NotLenovo, LSBV4.Utility.EventTypeEnum.SystemNotSupport, LSBV4.Utility.EventTypeEnum.UnhandledException, LSBV4.Utility.EventTypeEnum.WrongRequest, LSBV4.Utility.EventTypeEnum.ErrorLaunchTVSU, LSBV4.Utility.EventTypeEnum.ErrorDownloadTVSU, LSBV4.Utility.EventTypeEnum.LowVersion, LSBV4.Utility.EventTypeEnum.TVSUUpdateFailed);
            _this.dispatcher.BatchAddEventListener(function (data) {
                _this.EventHandler(data.Progress, data.Exception, data.IsCanceled, false, data);
                //console.log("ADUPStatusSuccess:::>>>>>>>>>>>>>>>>>>>>")
                //console.log(data);
            }, 
            //Success Event
            LSBV4.Utility.EventTypeEnum.ADUPStatusSuccess);
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.ADUPDetectInfoSuccess, function (data) {
                if (data && data.Sn) {
                    if (!_this.state.subSeries) {
                        l.Content.queryByKeywordsAsync(data.Sn, function (product) {
                            if (product && product.length && product.length > 0 && product[0].IsSupported === true && product[0].Name) {
                                _this.state.subSeries = product[0].Id.split('/')[2];
                                _this.setState(_this.state);
                            }
                        });
                    }
                }
            });
            _this.dispatcher.BatchAddEventListener(function (data) {
                _this.state.loading = false;
                _this.adupUpdateModel.updateItems.forEach(function (item) {
                    if (data.Packages != null && data.Packages.length != null && data.Packages.length > 0) {
                        var packageItem = data.Packages.filter(function (p) { return p.PackageId == item.ID; });
                        if (typeof packageItem != undefined && packageItem != null && packageItem.length != null && packageItem.length > 0) {
                            item.Status = packageItem[0].Status;
                        }
                    }
                });
                if (data.Action == LSBV4.Component.InstallPackageActionEnum.Downloading) {
                    _this.state.UpdateProgress = data.Progress / 2;
                }
                else if (data.Action == LSBV4.Component.InstallPackageActionEnum.Done) {
                    _this.state.Completed = true;
                    _this.state.loading = true;
                    _this.state.showReScan = true;
                    _this.state.UpdateProgress = 100;
                    var faileds = _this.adupUpdateModel.updateItems.filter(function (item) { return item.Status == LSBV4.Component.InstallPackageStatusEnum.install_fail; });
                    if (faileds.length > 0) {
                        _this.state.UpdateFailed = true;
                    }
                    if (_this.adupUpdateModel.rebootRequired === true && _this.adupUpdateModel.updateItems.length != faileds.length) {
                        _this.state.specialException = 'Installing Reboot Required';
                    }
                    ADUPTrack("eSupportProcess_Complete", "ADUP:InstallPackages-Complete", "System Generated");
                }
                else {
                    var completeCount = _this.adupUpdateModel.updateItems.filter(function (item) { return item.Status == LSBV4.Component.InstallPackageStatusEnum.install_successful || item.Status == LSBV4.Component.InstallPackageStatusEnum.install_fail; }).length;
                    _this.state.UpdateProgress = 50 + (((completeCount / _this.adupUpdateModel.updateItems.length) / 2) * 100);
                }
                _this.setState(_this.state);
                //console.log("ADUPInstallStatus:::>>>>>>>>>>>>>>>>>>>>")
                //console.log(data);
            }, 
            //Success Event
            LSBV4.Utility.EventTypeEnum.ADUPInstallStatus);
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.ADUPInstallPackageProcessFinished, function (data) {
                _this.state.loading = false;
                _this.setState(_this.state);
                if (_eventCallback) {
                    _eventCallback("install finished");
                    Cookies.set("TvsuLastRunStatus", 0, { expires: 365, path: '/' });
                }
                if (!window["ADUPInstallConfirmNo"]) {
                    window["ADUPInstallConfirmNo"] = false;
                    ADUPTrack("eSupportProcess_Complete", "ADUP:ADUPInstallPackageProcessFinished", "System Generated");
                }
            });
            //Handle with ADUPFailed special exception
            _this.dispatcher.BatchAddEventListener(function (data, eventType) {
                if (data != null) {
                    _this.state.ScanFailed = true;
                    _this.state.showCancel = false;
                    _this.state.showReStartBtn = true;
                    _this.state.specialException = 'ADUP Failed';
                    _this.setState(_this.state);
                }
                ADUPTrackError('ADUP', LSBV4.Utility.EventTypeEnum[eventType]);
            }, LSBV4.Utility.EventTypeEnum.ADUPFailed);
            _this.dispatcher.BatchAddEventListener(function (data, eventType) {
                if (data != null) {
                    _this.state.UpdateFailed = true;
                    _this.state.showReScan = true;
                    _this.state.showUpdate = false;
                    _this.state.specialException = 'ADUP Failed';
                    _this.setState(_this.state);
                }
                ADUPTrackError('ADUP', LSBV4.Utility.EventTypeEnum[eventType]);
            }, LSBV4.Utility.EventTypeEnum.ADUPInstallPackageFailed);
            _this.dispatcher.BatchAddEventListener(function (data) {
                if (_this.state.rstModel == AdupResultDisplay.scan) {
                    _this.state.ScanFailed = true;
                    _this.state.showCancel = false;
                    _this.state.showReStartBtn = true;
                    _this.state.ScanProgress = 0;
                }
                else {
                    _this.state.UpdateFailed = true;
                    _this.state.UpdateProgress = 0;
                    _this.state.Completed = true;
                    _this.state.showUpdate = false;
                    _this.state.showReScan = true;
                    _this.state.rstModel = AdupResultDisplay.scan;
                }
                if (_eventCallback) {
                    Cookies.set("TvsuLastRunStatus", 1, { expires: 365, path: '/' });
                    _eventCallback("default error");
                }
                l.DTM.Lmd.pusherrorinfTrack('ADUP', 'CommunicationFailed');
                _this.EventHandler(null, LSBV4.Component.ADUPExceptionEnum.CommunicationFailed, false);
            }, LSBV4.Utility.EventTypeEnum.ADUPFailed, LSBV4.Utility.EventTypeEnum.ADUPCancelFailed, LSBV4.Utility.EventTypeEnum.ADUPInstallPackageFailed, LSBV4.Utility.EventTypeEnum.InstallTVSUFailed, LSBV4.Utility.EventTypeEnum.InstallTVSUCancelFailed, LSBV4.Utility.EventTypeEnum.DownloadTVSUCancelFailed, LSBV4.Utility.EventTypeEnum.DownloadTVSUError);
            //Handle with no exception but need driver list
            _this.dispatcher.BatchAddEventListener(function (data, eventType) {
                _this.state.loading = false;
                _this.state.showUpdate = true;
                _this.state.UpdateActive = false;
                _this.state.UpdateProgress = 0;
                _this.state.rstModel = AdupResultDisplay.scan;
                _this.setState(_this.state);
                if (_eventCallback) {
                    setTimeout(function () {
                        _eventCallback("default error");
                    }, 500);
                }
                if (eventType != null) {
                    ADUPTrack("eSupportProcess_Complete", "ADUP:" + LSBV4.Utility.EventTypeEnum[eventType], "System Generated");
                }
            }, LSBV4.Utility.EventTypeEnum.ADUPInstallConfirmNo); //LSBV4.Utility.EventTypeEnum.ADUPCancelSuccess
            _this.dispatcher.BatchAddEventListener(function (data, eventType) {
                _this.setState(new AdupState());
            }, LSBV4.Utility.EventTypeEnum.ADUPCancelSuccess);
            _this.dispatcher.BatchAddEventListener(function (data, eventType) {
                _this.EventHandler(null, LSBV4.Component.ADUPExceptionEnum.UserCancelled, true);
                if (eventType == LSBV4.Utility.EventTypeEnum.UserCancelled) {
                    ADUPTrack("eSupportProcess_Complete", "ADUP:" + LSBV4.Utility.EventTypeEnum[eventType], "System Generated");
                }
            }, LSBV4.Utility.EventTypeEnum.UserCancelled, LSBV4.Utility.EventTypeEnum.DownloadTVSUCancel, LSBV4.Utility.EventTypeEnum.InstallTVSUCancelled);
            _this.dispatcher.BatchAddEventListener(function (data) {
                _this.EventHandler(null, LSBV4.Component.ADUPExceptionEnum.Waiting, false);
            }, LSBV4.Utility.EventTypeEnum.Waiting);
            _this.dispatcher.BatchAddEventListener(function (data) {
                LSBV4.Utility.Log('LSB install or update success');
                lsbInstall.LsbSetupClose();
                lsbInstallStatus.LsbUpdateClose();
                _this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.ADUP, _this.dispatcher.LastCommandType);
            }, LSBV4.Utility.EventTypeEnum.PingSuccess, LSBV4.Utility.EventTypeEnum.LSBUpdateSuccess);
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.ADUPCancelSuccess, function (data, eventType) {
                _this.EventHandler(null, LSBV4.Component.ADUPExceptionEnum.None, true);
            });
            _this.dispatcher.AddEventListener(LSBV4.Utility.EventTypeEnum.ADUPStatusFinish, function (data, eventType) {
                _this.state.loading = false;
                _this.setState(_this.state);
            });
        };
        _this.updateModel = function () {
            _this.adupExceptionModel.visible = (_this.state.exception !== LSBV4.Component.ADUPExceptionEnum.None && _this.state.exception !== LSBV4.Component.ADUPExceptionEnum.Waiting && _this.state.exception !== LSBV4.Component.ADUPExceptionEnum.NoTVSU) || (_this.state.specialException && _this.state.specialException != '');
            _this.adupExceptionModel.specialException = _this.state.specialException;
            _this.adupExceptionModel.exception = _this.state.exception;
        };
        _this.state = new AdupState();
        _this.ClickHandle = _this.ClickHandle.bind(_this);
        _this.selectHandle = _this.selectHandle.bind(_this);
        _this.dispatcher = props.dispatcher;
        _this.adupUpdateModel = new AdupUpdateModel();
        _this.adupExceptionModel = new adup_exception_3.AdupExceptionModel();
        _this.InitEventHandler();
        return _this;
    }
    Adup.prototype.componentDidMount = function () {
        if (this.props.pageType == 1) {
            this.ClickHandle();
        }
    };
    Adup.prototype.Init = function () {
        this.adupUpdateModel = new AdupUpdateModel();
        this.adupExceptionModel = new adup_exception_3.AdupExceptionModel();
    };
    Adup.prototype.IsWin7OrAbove = function () {
        return l.Common.isWin7OrAbove();
    };
    Adup.prototype.start = function () {
        if (this.IsWin7OrAbove() === true) {
            this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.ADUP, LSBV4.Component.CommandTypeEnum.ScanStatus);
            this.waitingTimer = new Date();
            TimeMonitor.start(TimeMonitor.scan);
            l.DTM.push({
                type: "eSupportProcess_Complete",
                name: "ADUP:StartScan",
                action: "Button Click" //Insert the action taken to request the new content
            });
        }
    };
    Adup.prototype.cancel = function () {
        this.dispatcher.ExecCommand(LSBV4.Component.ComponentTypeEnum.ADUP, LSBV4.Component.CommandTypeEnum.ScanCancel);
        // l.DTM.push({
        //     type: "eSupportProcess_Complete",
        //     name: "ADUP:Scan cancel",
        //     action: "Button Click"
        // });
        ADUPTrackError("ADUP", "Scan cancel");
    };
    Adup.prototype.selectHandle = function (index) {
        this.state.Drivers[index].Selected = !this.state.Drivers[index].Selected;
        this.adupUpdateModel.updateItems = this.state.Drivers.filter(function (item) { return item.Selected == true; });
        this.setState(this.state);
    };
    Adup.prototype.ClickHandle = function () {
        if (this.state.showStartBtn === true || this.state.showReStartBtn == true || this.state.showReScan === true) {
            var adupstate = new AdupState();
            adupstate.showStartBtn = false;
            adupstate.showReStartBtn = false;
            adupstate.showReScan = false;
            adupstate.showProgress = true;
            adupstate.ScanActive = true;
            adupstate.showCancel = true;
            adupstate.loading = true;
            this.Init();
            this.setState(adupstate);
            this.forceUpdate();
            this.start();
        }
        else if (this.state.showCancel === true) {
            this.state.loading = true;
            this.setState(this.state);
            this.cancel();
        }
        else if (this.state.showUpdate === true) {
            if (this.adupUpdateModel.updateItems.length < 1)
                return;
            this.state.showUpdate = false;
            this.state.loading = true;
            this.installPackage();
        }
    };
    Adup.prototype.EventHandler = function (overallProcess, exception, isCancelled, showResult, data) {
        var _this = this;
        if (showResult === void 0) { showResult = true; }
        this.state.loading = false;
        overallProcess = overallProcess ? overallProcess : 0;
        if (this.state.ScanProgress != overallProcess) {
            this.state.ScanProgress = overallProcess;
            this.setState(this.state);
        }
        if (overallProcess === 100 && data) {
            var RSTList = data.List == null ? [] : data.List;
            RSTList.forEach(function (item) {
                var ard = new AdupResultItemModel();
                $.extend(ard, item);
                ard.Selected = (item.Severity === 'Critical' || item.Severity === 'Recommended');
                if (ard.Selected == true) {
                    _this.adupUpdateModel.updateItems.push(ard);
                }
                _this.state.Drivers.push(ard);
            });
            this.state.showCancel = false;
            this.state.showUpdate = true;
            this.state.showRST = true;
            if (this.state.Drivers.length == 0) {
                if (_eventCallback) {
                    _eventCallback("no result");
                    Cookies.set("TvsuLastRunStatus", 0, { expires: 365, path: '/' });
                }
            }
            else {
                if (_eventCallback)
                    _eventCallback("got result");
            }
            this.setState(this.state);
            ADUPTrack("eSupportProcess_Complete", "ADUP:ScanComplete", "System Generated");
            Cookies.set("TvsuLastRunTime", new Date().toLocaleDateString(), { expires: 365, path: '/' });
            this.waitingTimer = new Date(2099, 1, 1);
        }
        if (isCancelled == true) {
            this.setState(new AdupState);
            if (this.props.AdupModeType == 1) {
                if (window["ExternalADUPCancelOrFaild"]) {
                    window["ExternalADUPCancelOrFaild"]();
                }
            }
            if (_eventCallback)
                _eventCallback("scan cancelled");
            //ADUPTrack("eSupportProcess_Complete", "ADUP:Cancel success", "System Generated");
        }
        if (exception && this.state.exception != exception) {
            this.state.exception = exception;
            this.setState(this.state);
            if (_eventCallback)
                _eventCallback("scan statue", exception);
        }
    };
    ;
    Adup.prototype.render = function () {
        this.updateModel();
        var stepModel = new AdupStepModel();
        stepModel.ScanActive = this.state.ScanActive;
        stepModel.ScanProgress = this.state.ScanProgress;
        stepModel.ScanFailed = this.state.ScanFailed;
        stepModel.UpdateActive = this.state.UpdateActive;
        stepModel.UpdateProgress = this.state.UpdateProgress;
        stepModel.UpdateFailed = this.state.UpdateFailed;
        stepModel.Completed = this.state.Completed;
        if (stepModel.ScanProgress == 100) {
            var updateCount = this.adupUpdateModel.updateItems.length;
            if (updateCount == 0) {
                stepModel.Completed = true;
                stepModel.UpdateProgress = 100;
            }
        }
        var rstModel = new AdupResultModel();
        rstModel.dispatcher = this.dispatcher;
        rstModel.Drivers = this.state.rstModel == AdupResultDisplay.update ? this.adupUpdateModel.updateItems : this.state.Drivers;
        rstModel.rebootRequired = (this.state.rstModel == AdupResultDisplay.update) ? this.adupUpdateModel.rebootRequired : rstModel.rebootRequired;
        rstModel.pattern = this.state.rstModel;
        rstModel.selectHandle = this.selectHandle;
        rstModel.active = this.state.showRST;
        var table = this.props.pageType == 1 ?
            React.createElement("div", null,
                this.state.showProgress ? null :
                    React.createElement("div", null,
                        React.createElement("div", { className: "dow-adup-head-content dow-adup-desc", style: { display: this.props.AdupModeType == 1 ? "none" : "block" } },
                            translates("automatic driver update description|Please note: Automatic system update will scan the system of your local device and get the latest available updates, which may not be the product that you are browsing."),
                            React.createElement("br", null),
                            React.createElement("br", null),
                            translates("click link to identify computer|Please check the link below to better identify your product."),
                            React.createElement("br", null),
                            React.createElement("a", { href: "https://support.lenovo.com/solutions/find-product-name", target: "_blank" }, translates("find product name|Help me find my product/serial numbe"))),
                        this.state.subSeries ? React.createElement("div", { className: "dow-adup-head-content dow-adup-desc" }, translates("you are currently running system update for x|You are currently running system update for " + this.state.subSeries, this.state.subSeries)) : null),
                React.createElement(adup_lastupdate_1.AdupTabButtonTitleLastUpdate, null),
                this.state.showStartBtn ? React.createElement("div", { className: "dow-adup-head-content" },
                    React.createElement("button", { id: "adup_scan_001", onClick: this.ClickHandle, className: "dow-adup-button" }, l.Translator.translate("adup start|Start Scan"))) : null)
            :
                React.createElement("table", { className: "dow-adup-table" },
                    React.createElement("tr", null,
                        React.createElement("td", { className: "text-right col-lg-3 col-md-3 col-xs-2", style: { display: this.props.AdupModeType == 1 ? "none" : "table-cell" } },
                            React.createElement("span", { className: "icon-adup dow-adup-psp-icon" })),
                        React.createElement("td", { className: "col-lg-6 col-md-7 col-xs-8" },
                            React.createElement("div", { className: "dow-adup-head-content dow-adup-desc", style: { display: this.props.AdupModeType == 1 ? "none" : "block" } },
                                translates("automatic driver update description|Please note: Automatic system update will scan the system of your local device and get the latest available updates, which may not be the product that you are browsing."),
                                React.createElement("br", null),
                                React.createElement("br", null),
                                translates("click link to identify computer|Please check the link below to better identify your product."),
                                React.createElement("br", null),
                                React.createElement("a", { href: "https://support.lenovo.com/solutions/find-product-name", target: "_blank" }, translates("find product name|Help me find my product/serial numbe"))),
                            this.state.subSeries ? React.createElement("div", { className: "dow-adup-head-content dow-adup-desc" }, translates("you are currently running system update for x|You are currently running system update for " + this.state.subSeries, this.state.subSeries)) : null,
                            React.createElement(adup_lastupdate_1.AdupTabButtonTitleLastUpdate, null)),
                        React.createElement("td", { className: "col-lg-3 col-md-2 col-xs-2", style: { display: this.props.AdupModeType == 1 ? "none" : "table-cell" } }, this.state.showStartBtn ? React.createElement("div", { className: "dow-adup-head-content" },
                            React.createElement("button", { id: "adup_scan_001", onClick: this.ClickHandle, className: "dow-adup-button" }, l.Translator.translate("adup start|Start Scan"))) : null)));
        var ButtonText = this.state.showCancel ? translates("adup cancel|Cancel Scan") : translates("update drivers|Update Drivers");
        ButtonText = this.state.showReStartBtn ? translates("scan again|Scan Again") : ButtonText;
        ButtonText = (this.state.rstModel == AdupResultDisplay.update && this.state.showReScan == true) ? translates("rescan|Rescan") : ButtonText;
        var ButtonClass = "dow-adup-button";
        ButtonClass = (this.state.showUpdate && updateCount == 0) ? "dow-adup-button-update dow-adup-button-disabled" : ButtonClass;
        ButtonClass = (this.state.showUpdate && updateCount > 0) ? "dow-adup-button-update " : ButtonClass;
        var btnStatus = this.state.showUpdate == true && updateCount > 0 || this.state.showCancel == true || this.state.showReStartBtn == true || this.state.showReScan == true;
        return React.createElement("div", { className: "dow-adup-container" },
            table,
            this.state.showProgress ?
                React.createElement("div", null,
                    React.createElement("div", { className: "" + (btnStatus ? 'col-lg-10 col-md-9 col-sm-7 col-xs-12 dow-adup-clear-padding' : '') },
                        React.createElement(AdupStep, __assign({}, stepModel))),
                    btnStatus ?
                        React.createElement("div", { className: "col-lg-2 col-md-3 col-sm-5 col-xs-12 text-right dow-adup-button-section" },
                            React.createElement("button", { className: ButtonClass, onClick: this.ClickHandle },
                                ButtonText,
                                this.state.showUpdate ? React.createElement("span", null, updateCount) : null)) : null)
                :
                    null,
            React.createElement(adup_exception_4.AdupException, __assign({}, this.adupExceptionModel)),
            React.createElement(AdupResult, __assign({}, rstModel)),
            React.createElement(adup_load_1.AdupLoad, { isShow: this.state.loading }));
    };
    return Adup;
}(React.Component));
exports.adupload = function (element, adupModeType, pageType, eventCallBack) {
    if (adupModeType === void 0) { adupModeType = 0; }
    if (pageType === void 0) { pageType = 0; }
    lsbInstallStatus.LsbUpdateRender();
    _eventCallback = eventCallBack;
    var model = new AdupModel();
    model.dispatcher = LSBV4.Dispatcher.GetDispatcher();
    model.AdupModeType = adupModeType;
    model.pageType = pageType;
    ReactDOM.render(React.createElement(Adup, __assign({}, model)), element);
};
